export const WIDGET_DATA_TRANSFER_TYPE = 'application/x-widget'
